module.exports = __webpack_public_path__ + "img/sunshine_900.a176018b.png";